var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expand-row"},[_c('Table',{attrs:{"border":"","stripe":"","columns":_vm.columns2,"data":_vm.row},scopedSlots:_vm._u([{key:"put_company_name",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.put_company.company_name)+" ")]}},{key:"enter_company_name",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.enter_company.company_name)+" ")]}},{key:"title",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.coupon_categories.title)+" ")]}},{key:"alias",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.coupon_categories.alias)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }